import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';
import { EmployeeRoutes } from '../../api/routes/api-employee-routes';

export const executeMergeEmployees = (
  employeeToKeepId: number,
  employeeToRemoveId: number,
  orgId: number,
  mergeResolutions: EmployeeMergeResolutionApiType,
) =>
  createGenericDispatcher({
    name: 'MERGE_EMPLOYEES',
    loadFunction: () =>
      Api.post(`${EmployeeRoutes.getBaseRoute(employeeToKeepId)}/merge`, {
        body: JSON.stringify({
          employeeToKeepId,
          employeeToRemoveId,
          mergeResolutions,
        }),
      }),
    args: { employeeToRemoveId, orgId },
  });
